export default {
  selectInfo: '/v3/recruit/equipment/selectInfo',
  cityStatus: '/mobileCard/client/cityConf',
  showInRecruit: '/mobileCard/client/showInRecruit'
}
